import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Order } from 'src/app/shared';
import { SubSink } from 'subsink';
import { AdminUnconfirmSharedFileComponent } from '../admin-unconfirm-shared-file/admin-unconfirm-shared-file.component';

@Component({
  selector: 'app-admin-order-error-report',
  templateUrl: './admin-order-error-report.component.html',
  styleUrls: ['./admin-order-error-report.component.sass'],
})
export class AdminOrderErrorReportComponent implements OnInit {
  private subsink = new SubSink();

  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) data: Order
  ) {}
  ngOnInit(): void {}

  public report() {
    this.subsink.sink = this.dialog
      .open(AdminUnconfirmSharedFileComponent, {
        width: '400px',
      })
      .afterClosed()
      .subscribe((data: any | undefined) => {
        if (data) {
        }
      });
  }

  ngOnDestroy() {
    this.subsink.unsubscribe();
  }
}
